import android from './android'
import ios from './ios'

const integrations = [android, ios]

const init = () => {
  integrations.forEach(integration => integration.init())
}

const postMessage = args => {
  integrations.forEach(integrations => integrations.postMessage(args))
}

export default {
  init,
  postMessage
}
